import {
    PERSIST_EXPANDED_ROUTES
    ,PERSIST_SET_THEME_LIGHT
    ,PERSIST_SET_EDIT_MODE
    ,PERSIST_PORTFOLIO_DEFAULT_VIEW
    ,PERSIST_ROLE_ACTIVE_NAME
    ,PERSIST_PAGE_ROLE_DEFAULT_VIEW
    ,PERSIST_SETTINGS_DRAWERS_OPEN
    // GANTT
    ,PERSIST_GANTT_EXPANDED_TASKIDS
} from "./persistTypes";

export function persistExpandedRoutes(routes) {
    return {
        type: PERSIST_EXPANDED_ROUTES,
        payload: routes
    }
}

export function persistSetThemeLight(themeLight) {
    return {
        type: PERSIST_SET_THEME_LIGHT,
        payload: themeLight
    }
}

export function persistSetEditing(isEditing) {
    return {
        type: PERSIST_SET_EDIT_MODE,
        payload: isEditing
    }
}

export function persistActiveRoleName(activeRoleName) {
    return {
        type: PERSIST_ROLE_ACTIVE_NAME,
        payload: activeRoleName
    }
}

export function persistRolePageDefaultView(page, role, flipped) {
    return (dispatch, getState) => {
        const state = getState();

        const flipStates = state.persist.flipStates;

        const flipState = flipStates.find(f => f.key === page + role);
        if (!flipState) {
            flipStates.push({
                key: page + role,
                flipped: flipped
            });
        }
        else {
            flipState.flipped = flipped;
        }

        return {
            type: PERSIST_PAGE_ROLE_DEFAULT_VIEW,
            payload: flipStates
        }
    }
}

export function persistPortfolioDefaultView(isTable) {
    return {
        type: PERSIST_PORTFOLIO_DEFAULT_VIEW,
        payload: isTable
    }
}

export function persistSettingsDrawersOpen(settingsDrawer) {
    return (dispatch, getState) => {
        const state = getState();
        let stateDrawers = state.persist.settingsDrawersOpen;

        if (Array.isArray(stateDrawers)) {
            // Does path's settings drawer already persist?
            const drawerIndex = stateDrawers.findIndex((obj => obj.drawer === settingsDrawer.drawer));
            if (drawerIndex >= 0) {
                stateDrawers[drawerIndex] = settingsDrawer;
            } else {
                stateDrawers.push(settingsDrawer);
            }
        } else {
            stateDrawers = [settingsDrawer];
        }

        // Persist Settings Drawer
        dispatch({
            type: PERSIST_SETTINGS_DRAWERS_OPEN,
            payload: stateDrawers
        });

    }
}

export function persistGanttAddExpandedTask(id) {
    return (dispatch, getState) => {
        const state = getState();
        let expandedGanttTaskIDs = state.persist.expandedGanttTaskIDs;

        if (expandedGanttTaskIDs.indexOf(id) >= 0)
            return;

        expandedGanttTaskIDs.push(id);

        dispatch({
            type: PERSIST_GANTT_EXPANDED_TASKIDS,
            payload: expandedGanttTaskIDs
        });
    }
}

export function persistGanttRemoveExpandedTask(id) {
    return (dispatch, getState) => {
        const state = getState();
        let expandedGanttTaskIDs = state.persist.expandedGanttTaskIDs;

        if (expandedGanttTaskIDs.indexOf(id) < 0)
            return;

        expandedGanttTaskIDs = expandedGanttTaskIDs.splice(expandedGanttTaskIDs.indexOf(id), 1);

        dispatch({
            type: PERSIST_GANTT_EXPANDED_TASKIDS,
            payload: expandedGanttTaskIDs
        });
    }
}
